import React, { useState, useContext, useEffect } from "react";
import logo from "../../assets/01pos.webp";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import RealTimeClock from "./RealTimeClock";
import { useNavigate } from "react-router";
import ConfirmModal from "../../components/ConfirmModal";
import GeneratePin from "./GeneratePin";
import { CustomerContext } from "../CashierHomepage";
import { Badge } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import CalculateIcon from "@mui/icons-material/Calculate";
import Calculator from "../../utility/Calculator";

function ProductsHeader() {
  const {
    setOpenDraft,
    openMessage,
    barcodeScan,
    openGeneratePassword,
    setOpenMessage,
    setOpenGeneratePassword,
    setBarcodeScan,
    totalUnreadMessages,
  } = useContext(CustomerContext);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleChat = () => {
    setOpenMessage(!openMessage);
    setOpenDraft(false);
    setOpenGeneratePassword(false);
    setBarcodeScan(false);
  };

  const handleCalculator = () => {
    setBarcodeScan(!barcodeScan);
    setOpenMessage(false);
    setOpenDraft(false);
    setOpenGeneratePassword(false);
  };

  const handleGeneratePasscode = () => {
    setOpenMessage(false);
    setOpenDraft(false);
    setOpenGeneratePassword(!openGeneratePassword);
    setBarcodeScan(false);
  };

  const handleQuit = () => {
    setIsModalOpen(true); // Open the confirmation modal
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
  };

  const navigate = new useNavigate();
  const handleConfirmQuit = () => {
    sessionStorage.clear();

    navigate("/login");
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <header className="flex flex-row justify-between bg-black h-12 px-3 items-center">
      {/* <img src={logo} className="w-20 " alt="logo of the company" /> */}
      <h2 className="font-bold text-white text-2xl">01POS</h2>
      <RealTimeClock />
      <div className="flex flex-row justify-between gap-3 items-center">
        <Badge
          color="secondary"
          sx={{
            "& .MuiBadge-badge": {
              fontSize: "8px", // Reduce font size
              width: "12px", // Reduce the size of the badge circle
              height: "16px", // Reduce the size of the badge circle
            },
          }}
          badgeContent={totalUnreadMessages}
        >
          <ChatBubbleOutlineIcon
            className="text-white cursor-pointer hover:text-blue-500"
            onClick={handleChat}
          />
        </Badge>
        <GeneratePin handleGeneratePasscode={handleGeneratePasscode} />

        <CalculateIcon
          className="text-white cursor-pointer "
          onClick={handleCalculator}
        />
        <RefreshIcon
          onClick={handleRefresh}
          className="text-white cursor-pointer hover:text-green-500"
        />
        <ExitToAppIcon
          onClick={handleQuit}
          className="text-white cursor-pointer hover:text-red-500"
        />
      </div>
      {barcodeScan && <Calculator handleClose={setBarcodeScan} />}
      <ConfirmModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmQuit}
        text1="Confirm Quit"
        text2="Are you sure you want to quit the app?"
        close={"No"}
        accept={"Yes"}
      />
    </header>
  );
}

export default ProductsHeader;
